<template>
    <vx-badge v-if="props.static" size="xs"
        :color="experimental.color"
        :class="{ 'opacity-40': props.disabled }">
        <span>
            {{ experimental.label }}
        </span>
        <font-awesome-icon widthAuto :icon="experimental.icon"></font-awesome-icon>
    </vx-badge>
    <div v-else class="relative">
        <vx-popover @click.stop
            :arrow="true"
            :hover="false"
            :teleport="false"
            placement="top"
            @open="isOpen = true"
            @close="isOpen = false">
            <vx-badge size="xs"
                :color="experimental.color"
                class="cursor-pointer">
                <button type="button"
                    class="inline-flex items-center gap-1.5 cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-blue-500"
                    :aria-label="`${experimental.label} feature`"
                    :aria-expanded="isOpen"
                    data-test="experimental-pill">
                    <span>
                        {{ experimental.label }}
                    </span>
                    <font-awesome-icon widthAuto :icon="experimental.icon"></font-awesome-icon>
                </button>
            </vx-badge>
            <template v-slot:content>
                <div class="flex flex-col font-sans p-2 lg:w-[286px]">
                    <div class="font-sans text-slate-700 text-lg font-extrabold mb-1">
                        <font-awesome-icon widthAuto :icon="experimental.icon"
                            class="mr-1"></font-awesome-icon> {{ experimental.label }} Feature
                    </div>
                    <p class="font-sans text-slate-700 text-xs! mb-3 font-normal">
                        This feature is still in the testing phase. We encourage you to <strong>provide feedback</strong> or
                        <strong>report issues</strong> so we can make your experience better!
                    </p>
                    <vx-button color="info"
                        size="sm"
                        :href="`mailto:support@voxie.com?subject=${subject}`"
                        target="_blank"
                        rel="noopener noreferrer"
                        data-test="experimental-feedback">
                        Submit Feedback
                        <font-awesome-icon widthAuto :icon="faMessageLines"></font-awesome-icon>
                    </vx-button>
                </div>
            </template>
        </vx-popover>
    </div>
</template>

<script setup>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faFlask, faMessageLines, faVialVirus } from '@fortawesome/pro-solid-svg-icons';
import { VxBadge, VxPopover, VxButton } from '@voxie/frontend-components';
import { computed, ref } from 'vue';

const props = defineProps({
    subject: String,
    type: {
        type: String,
        default: 'beta',
    },
    disabled: Boolean,
    static: Boolean,
});


const isOpen = ref(false);

const experimental = computed(() => {
    if (props.type === 'alpha') {
        return {
            color: 'fuchsia',
            label: 'Alpha',
            icon: faVialVirus,
        }
    }

    return {
        color: 'amber',
        label: 'Beta',
        icon: faFlask,
    }
})

const subject = computed(() => encodeURIComponent(props.subject || `${experimental.value.label} Feedback`));
</script>
